/* Secret Scenta – availability fallback 19 Sep 2026. */
(() => {
  'use strict';

  const addBrowseFallback = () => {
    document.querySelectorAll('.pdp-market-stock__alts').forEach((box) => {
      if (box.querySelector('.pdp-market-stock__browse')) return;
      const link = document.createElement('a');
      link.href = '/collections/diffusers';
      link.className = 'pdp-market-stock__alt pdp-market-stock__browse';
      link.textContent = 'Voir les autres diffuseurs';
      box.appendChild(link);
    });

    const pdp = document.querySelector('[data-pdp]');
    const atc = pdp?.querySelector('[data-atc]');
    if (!pdp || !atc?.disabled || pdp.querySelector('.pdp-market-stock')) return;

    const note = pdp.querySelector('[data-unavailable-note]');
    if (note) note.hidden = false;

    const panel = document.createElement('div');
    panel.className = 'pdp-market-stock pdp-market-stock--soldout';
    panel.innerHTML = '<p class="pdp-market-stock__message"><strong>Victime de son succès.</strong> Cette finition n’est plus disponible pour le moment.</p><div class="pdp-market-stock__alts"><span>Vous pouvez continuer avec :</span><a href="/collections/diffusers" class="pdp-market-stock__alt pdp-market-stock__browse">Voir les autres diffuseurs</a></div>';
    (note || pdp.querySelector('.pdp__options:last-of-type') || atc).insertAdjacentElement('afterend', panel);
  };

  addBrowseFallback();
  document.addEventListener('shopify:section:load', addBrowseFallback);
})();
